import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import modalSlickAlt from 'src/images/modalSlickAlt.png';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { trackingList } from 'src/utils/valueHTML';
import { getFontURL } from 'src/utils/getFontUrl';

const TEXT_2_JUSTIFY = {
  left: 'start',
  center: 'center',
  right: 'end'
};

const SimpleModalSlideHTML: FC = () => {
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);

  const multiTitleFontURL = getFontURL(fontFamily?.multi_title);
  const multiSubTitleFontURL = getFontURL(fontFamily?.multi_sub_title);
  const multiBoxTitleFontURL = getFontURL(fontFamily?.multi_box_title);
  const multiLeftButtonFontURL = getFontURL(btnFontFamily?.multi_left_button);
  const multiRightButtonFontURL = getFontURL(btnFontFamily?.multi_right_button);
  // const multiTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_title}`;
  // const multiSubTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_sub_title}`;
  // const multiBoxTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_box_title}`;
  // const multiLeftButtonFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_left_button}`;
  // const multiRightButtonFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_right_button}`;

  const style = `
  @Font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleFontURL});
  }
  @Font-face {
    font-family: 'multiSubTitle';
    src: url(${multiSubTitleFontURL});
  }
  @Font-face {
    font-family: 'multiBoxTitle';
    src: url(${multiBoxTitleFontURL});
  }
  @Font-face {
    font-family: 'multiLeftButton';
    src: url(${multiLeftButtonFontURL});
  }
  @Font-face {
    font-family: 'multiRightButton';
    src: url(${multiRightButtonFontURL});
  }
    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;

      overflow: hidden;
      position: relative;
      background: none;

      display: flex;
      justify-content: center;
    }
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
    }
    .modal_wrapper {
      width: calc(100% - 76px);      

      display: flex;
      flex-direction: column;
      gap: 1rem;

      position: absolute;
      top: 50%;
      transform: translate(0%, -50%);
      
      overflow: hidden;
      border-radius: ${radius?.multi_image}px;
      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `
          background: linear-gradient(to top, ${bgColor?.background} 11.25rem, transparent 0);
          `
      };
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list,
    .slick_wrapper .slick-track div,
    .slick_wrapper .slick-track img {
      width: 100%;
      aspect-ratio: 1;
      outline: none;
    }
    .slick_wrapper .slick-track img {
      object-fit: cover;
    }

    .slick_wrapper .image_box {
      width: 100%;
      height: 100%;
      position: relative;
    }
    .image_box .title_box {
      width: 100%;
      height: 5.875rem;
      padding: 1rem;

      position: absolute;
      bottom: 0;
      z-index: 1;
    }
    .image_box .title {
      width: 100%;
      height: 1.5rem;
      margin-bottom: 0.5rem;
      
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    
      text-align: ${textAlign?.multi_title};
      color: ${color?.multi_title};
      font-size: ${fontSize?.multi_title}rem;
      font-weight: ${fontWeight?.multi_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_title
        )
          ? fontFamily?.multi_title
          : 'multiTitle'
      };
    }
    .image_box .sub_title {
      width: 100%;
      height: 1.75rem;

      display: flex;
      align-items: center;
    
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.multi_sub_title};
      color: ${color?.multi_sub_title};
      font-size: ${fontSize?.multi_sub_title}rem;
      font-weight: ${fontWeight?.multi_sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_sub_title
        )
          ? fontFamily?.multi_sub_title
          : 'multiSubTitle'
      };
    }

    .contents_wrapper,
    .contents_box .title {
      height: 3.5rem;
    }
    .contents_box {
      height: 3.5rem;
      padding: 0 1.5rem;
    }
    .contents_box .title {
      display: flex;
      justify-content: ${TEXT_2_JUSTIFY[textAlign?.multi_box_title]};
      align-items: center;

      text-align: ${textAlign?.multi_box_title};
      color: ${color?.multi_box_title};
      font-size: ${fontSize?.multi_box_title}rem;
      font-weight: ${fontWeight?.multi_box_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_box_title
        )
          ? fontFamily?.multi_box_title
          : 'multiBoxTitle'
      };
    }

    .slick-dots {
      margin-bottom: 6px;
    }
    .slick-dots li {
      width: 4px;
      height: 4px;
      margin: 0 0.5rem;
    }
    .slick-dots li button {
      width: 4px;
      height: 4px;
      padding: 0;
      border-radius: 4px;
      background: black;
      opacity: 0.3;
    }
    .slick-dots .slick-active button {
      opacity: 1;
    }
    .slick-dots li button::before {
      width: 4px;
      height: 4px;
      padding: 0;
      display: none;
    }

    .bar_blank {
      width: 100%;
      min-height: 0.25rem;
    }
    .btn_wrapper {
      width: 100%;
      height: 2.5rem;
      padding: 0 1rem;
      margin-bottom: 1rem;

      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
    }
    .btn_wrapper button {
      border: 0;
      background-color: transparent;
    }
    .btn_wrapper .style01 {
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.multi_left_button}rem;
      font-weight: ${btnFontWeight?.multi_left_button};
      color: ${btnColor?.multi_left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_left_button
        )
          ? btnFontFamily?.multi_left_button
          : 'multiLeftButton'
      };

      border-radius: ${radius?.multi_left_button}px;
      background-color:rgba(${btnBgColorR?.multi_left_button},${
    btnBgColorG?.multi_left_button
  }, ${btnBgColorB?.multi_left_button}, ${btnBgColorA?.multi_left_button});
    }
    .btn_wrapper .style02 {
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      font-size: ${btnFontSize?.multi_right_button}rem;
      font-weight: ${btnFontWeight?.multi_right_button};
      color: ${btnColor?.multi_right_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_right_button
        )
          ? btnFontFamily?.multi_right_button
          : 'multiRightButton'
      };

      border-radius: ${radius?.multi_right_button}px;
      background-color:rgba(${btnBgColorR?.multi_right_button},${
    btnBgColorG?.multi_right_button
  }, ${btnBgColorB?.multi_right_button}, ${btnBgColorA?.multi_right_button});
    }

    @media screen and (min-width: 568px) and (max-width: 1024px) {
      .modal_wrapper {
        width: 314px;                
      }
    }
  `;
  const deeplink_list = JSON.stringify(deeplink?.multi_image);

  const html = `
    <div class="root">
      <div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
      <div class="modal_wrapper">
        <div class="slick_wrapper">
          <div class="slick_slider">${bgImage?.multi_image
            ?.map(
              (data: any, idx: number) => `
          <div class="image_box">
            <img
              class="image"
              src="${data && data !== '' ? data : modalSlickAlt}"
              alt=""
            />
            <div class="title_box">
              <div class=" title">${changeEnterHTML(
                text?.multi_title?.[idx]
              )}</div>
              <div class="sub_title">
                ${changeEnterHTML(text?.multi_sub_title?.[idx])}
              </div>
            </div>
          </div>
        `
            )
            .join('')}
          </div>
        </div>
        <div class="contents_wrapper">
          <div class="contents_slider">${text?.multi_title
            ?.map(
              (data: any, idx: number) => `
        <div class="contents_box">
          <div class="title">${changeEnterHTML(
            text?.multi_box_title?.[idx]
          )}</div>
        </div>
      `
            )
            .join('')}
          </div>
        </div>
        <div className="bar_blank"></div>
        <div class="btn_wrapper">
          <button class="style01">
            ${btnText?.multi_left_button}
          </button>
          <button class="style02">
            ${btnText?.multi_right_button}
          </button>
        </div>
      </div>
      <div id="deeplink_list" style="display:none;">
        ${deeplink_list}
      </div>
    </div>
  `;

  // let deeplink_list = `[`;
  // for (let i = 0; i < deeplink?.multi_image?.length; i++) {
  //   deeplink_list += `"${deeplink?.multi_image?.[i]}"`;
  //   if (i !== deeplink?.multi_image?.length - 1) deeplink_list += ',';
  // }
  // deeplink_list += ']';

  let button_list = '[';
  for (let i = 0; i < btnText?.multi_left_button?.length; i++) {
    button_list += `['${btnText?.multi_left_button?.[i]}', '${btnText?.multi_right_button?.[i]}']`;
    if (i !== btnText?.multi_left_button?.length - 1) button_list += ',';
  }
  button_list += ']';

  let tracking_list = '[';
  for (let i = 0; i < tracking?.multi_image?.length; i++) {
    tracking_list += `['${tracking?.multi_image?.[i]}', '${tracking?.multi_left_button?.[i]}', '${tracking?.multi_right_button?.[i]}'],`;
  }
  tracking_list += ']';

  const tracking_button_list = trackingList(
    'SIMPLE MODAL SLIDE',
    button1,
    button2
  );

  const js = `
  document.addEventListener("DOMContentLoaded", function(){
    $('.slick_slider').slick({
      arrows: false,
      dots: false,
  
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 300,
      touchThreshold: 300
    });

    $('.contents_slider').slick({
      arrows: false,
      dots: true,
      fade: true,
  
      speed: 300,
      swipe: false
    });

    let currentIndex = 0;
    let button = ${button_list};
    $('.style01').text(button[currentIndex][0]);
    $('.style02').text(button[currentIndex][1]);
    $('.slick_number').text(currentIndex+1);
    $('.slick_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      currentIndex = $('.slick_slider').slick('slickCurrentSlide');
      $('.contents_slider').slick('goTo', currentIndex);
      $('.slick_number').text(currentIndex+1);
      $('.style01').text(button[currentIndex][0]);
      $('.style02').text(button[currentIndex][1]);
    });
    $('.contents_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      currentIndex = $('.contents_slider').slick('slickCurrentSlide');
      $('.slick_slider').slick('goTo', currentIndex);
      $('.slick_number').text(currentIndex+1);
      $('.style01').text(button[currentIndex][0]);
      $('.style02').text(button[currentIndex][1]);
    });
    let content = $("#deeplink_list").text();
    
		// 불필요한 줄바꿈과 탭 문자를 제거합니다.
		let link = content.replace(/\\n|\\t/g, "").trim();
		
		let deeplink = JSON.parse(link);
    
    let tracking = ${tracking_list};
    let button1 = ${tracking_button_list[0]};
    let button2 = ${tracking_button_list[1]};
    $('.image').click(function() {
      appboyBridge.logClick(tracking[currentIndex][0]);
      try {
        if (button1[0].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[0].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = deeplink[currentIndex];
    });
    $('.style01').click(function() {
      appboyBridge.logClick(tracking[currentIndex][1]);
      try {
        if (button1[1].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[1].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      appboyBridge.closeMessage();
    });
    $('.style02').click(function() {
      appboyBridge.logClick(tracking[currentIndex][2]);
      try {
        if (button1[2].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[2].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = deeplink[currentIndex];
    });
  });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Pragma" content="no-cache" />

        {/* slick */}
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css"
        />
        <script
          type="text/javascript"
          src="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js"
        />

        {/* google font */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick-theme.css"
        />

        {/* jquery */}
        <script src="https://code.jquery.com/jquery-3.6.0.min.js" />
        <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.js" />
        <style dangerouslySetInnerHTML={{ __html: style }} />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};

export default SimpleModalSlideHTML;
